import React, { useContext, useState, useEffect } from "react";
import { io } from "socket.io-client";
import Header from "../Common/Header";
import Sidebar from "../Common/Sidebar";
import Footer from "../Common/Footer";
import { GMCContext } from "../../GMCContext";
import Swal from "sweetalert2";
import Copy from "../Common/Copy";
import axios from "axios";
import Web3 from "web3";
import Pagination from "../Common/Pagination";
import useEthersSigner from "./useEthersSigner";
import { Contract, ethers, utils } from "ethers";

// const socket = io(process.env.REACT_APP_BACKEND_LINK.replace("/api/gtbs", ""), {
//     transports: ["websocket", "polling"],
// });
const socket = io(process.env.REACT_APP_SOCKET_URL, {
  transports: ["websocket", "polling"],
});

socket.on("connect", () => {
  console.log("🔥 Socket connected to backend:", socket.id);
});

socket.on("connect_error", (err) => {
  console.error("❌ Socket connection error:", err.message);
});

export default function PendingWithdrwalsidebar() {
  const {
    togel,
    setTogel,
    isSidebarEnabled,
    setIsSidebarEnabled,
    web3,
    formatDateTime,
    settings,
    toastSuccess,
    toastError,
    account,
    connectMetamask,
    formatAddress,
    disconnectNow,
  } = useContext(GMCContext);
  const signer = useEthersSigner();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authNumber, setAuthNumber] = useState("");
  const [msg, setMsg] = useState("");
  const [showMsg, setShowMsg] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [error, setError] = useState(false);
  const [txHash, setTxHash] = useState("");
  const [showBlocker, setShowBlocker] = useState(false);
  const [blockerStatus, setBlockerStatus] = useState("loading"); // loading | success | error

  const [value, setValue] = useState(0);
  const [trdone, settrdone] = useState(true);
  const [fromdate, setfromdate] = useState(null);
  const [todate, settodate] = useState(null);
  const [selected_address, setselected_address] = useState([]);
  const [selected_username, setselected_username] = useState([]);
  const [selected_address_amt, setselected_address_amt] = useState([]);
  const [selected_address_amt_as, setselected_address_amt_as] = useState([]);
  // console.log('contract', settings[0]?.withdrawal_contract)
  const [progress, setProgress] = useState({
    total: 0,
    completed: 0,
    status: "idle",
  });

  const [jobId, setJobId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const TABLE_COL_SPAN = 9;
  const isWithdrawalProcessing =
    progress.status === "processing" ||
    (showBlocker && blockerStatus === "loading");

  const clearAllState = () => {
    setSearch("");
    setCurrentPage(1);
    setPageSize(10);
    setPages(1);
    setdata([]);
    setfromdate(null);
    settodate(null);
    setselected_address([]);
    setselected_username([]);
    setselected_address_amt([]);
    setselected_address_amt_as([]);
    setValue(0);
    settrdone(true);
    setTxHash("");
    setJobId(null);
    setProgress({ total: 0, completed: 0, status: "idle" });
    setShowBlocker(false);
    setBlockerStatus("loading");
    const selectAllChk = document.getElementById("chkbox");
    if (selectAllChk) selectAllChk.checked = false;
  };

  const handleRefresh = () => {
    clearAllState();
    setRefreshKey((k) => k + 1);
  };

  const randomHash = utils.id(Math.random().toString());
  // console.log('randomhash', randomHash);

  const insertCode = async () => {
    try {
      const state = JSON.parse(localStorage.getItem("mark#0143"));
      const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "verify",
        submethod: "insert",
        key: process.env.REACT_APP_KEY,
        authNumber,
        username: state.username,
        _id: state._id,
      });

      const { resCode, error, token } = response.data;

      if (resCode === 200 && token) {
        setMsg("Verified Successfully");
        setShowMsg(true);
        setIsAuthenticated(true);
      } else {
        setErrorMessage(error || "Verification Failed. Please Try Again.");
        setError(true);
      }
    } catch (err) {
      console.error("Error Inserting Data:", err);
      setErrorMessage("Network Error. Please Try Again Later.");
      setError(true);
    }
  };

  const getData = async () => {
    try {
      setLoading(true);
      setdata([]);

      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "withdrawal",
        submethod: "getp",
        key: process.env.REACT_APP_KEY,
        search,
        type: 1,
        fromdate,
        todate,
        page: currentPage,
        pageSize,
      });

      if (res.data?.resCode === 200 && Array.isArray(res.data?.data)) {
        setdata(res.data.data);
        setPages(Math.ceil((res.data.total || 0) / pageSize) || 1);
      } else if (Array.isArray(res.data?.data)) {
        setdata(res.data.data);
        setPages(Math.ceil((res.data.total || 0) / pageSize) || 1);
      } else {
        setdata([]);
        setPages(1);
      }
    } catch (err) {
      console.log("Error : ", err);
      setdata([]);
      setPages(1);
      toastError("Failed to fetch pending withdrawals");
    } finally {
      setLoading(false);
    }
  };

  const selectAll = (event) => {
    if (event?.target?.checked) {
      // Reset arrays and total amount to start fresh
      let allSelectedAddresses = [];
      let allSelectedUsername = [];
      let allSelectedAmountsWei = [];
      let allSelectedAmounts = [];
      let totalAmount = 0;

      // Loop through all data to check each item and accumulate values
      data.forEach((item, index) => {
        const checkbox = document.getElementById(`chkbox${index}`);
        if (checkbox) checkbox.checked = true; // Check the checkbox

        const address = item?.sAddress || ""; // fallback to empty string if address is missing
        const username = item?.username || "Unknown User"; // fallback if username is missing
        const amount = parseFloat(item?.amount) || 0; // fallback to 0 if amount is missing or invalid
        const token = parseFloat(item?.totalrcv || 0);
        const amountWei = ethers.utils.parseEther(token.toFixed(18).toString());

        allSelectedAddresses.push(address);
        allSelectedUsername.push(username);
        allSelectedAmountsWei.push(amountWei);
        allSelectedAmounts.push(amount);
        totalAmount += token;
      });

      // Update state with new selection
      setselected_address(allSelectedAddresses);
      setselected_username(allSelectedUsername);
      setselected_address_amt(allSelectedAmountsWei);
      setselected_address_amt_as(allSelectedAmounts);
      setValue(parseFloat(totalAmount.toFixed(10)));
    } else {
      // Uncheck all checkboxes and reset state
      data.forEach((item, index) => {
        const checkbox = document.getElementById(`chkbox${index}`);
        checkbox.checked = false; // Uncheck the checkbox
      });

      setselected_address([]);
      setselected_username([]);
      setselected_address_amt([]);
      setselected_address_amt_as([]);
      setValue(0);
    }
  };

  const { JsonRpcProvider } = ethers.providers; // Import JsonRpcProvider from the providers namespace

  const withdrawMultiple = async () => {
    if (!signer) {
      toastError("Signer Is Not Available");
      return;
    }

    if (selected_address.length === 0) {
      toastError("Please select at least one address");
      return;
    }

    setShowBlocker(true);
    setBlockerStatus("loading");
    settrdone(false);

    try {
      // console.log('settings[0]', settings[0]);

      const contract = new Contract(
        settings[0].withdrawal_contract,
        JSON.parse(settings[0].withdrawal_contract_abi),
        signer,
      );

      const totalValueWei = selected_address_amt.reduce(
        (sum, val) => sum.add(ethers.BigNumber.from(val)),
        ethers.BigNumber.from(0),
      );

      // console.log("Sending transaction with:", selected_address, selected_address_amt, totalValueWei.toString());

      const tx = await contract.Withdrawal(
        selected_address,
        selected_address_amt,
        totalValueWei,
      );
      // console.log('tx', tx);
      setTxHash(tx.hash);
      setJobId(tx.hash);

      // console.log("Transaction sent, hash:", tx.hash);
      // const receipt = await tx.wait();
      // console.log("Transaction confirmed:", receipt);

      // Call backend API to register the withdrawal
      const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "withdrawal",
        submethod: "masswithdrw",
        key: process.env.REACT_APP_KEY,
        hash: tx.hash,
        address: selected_address,
        username: selected_username,
        amount: selected_address_amt_as,
        enterhash: randomHash,
        total: value,
      });
      // console.log('response', response);

      if (response.data.error) {
        toastError(response.data.error);
      } else {
        // toastSuccess("Withdrawal Processed Successfully");

        // Uncheck checkboxes
        selected_address.forEach((_, i) => {
          const checkbox = document.getElementById(`chkbox${i}`);
          if (checkbox) checkbox.checked = false;
        });

        const allCheckbox = document.getElementById("chkbox");
        if (allCheckbox) allCheckbox.checked = false;

        getData();
        setselected_address([]);
        setselected_username([]);
        setselected_address_amt([]);
        setselected_address_amt_as([]);
        setValue(0);
        setBlockerStatus("success");
      }
    } catch (err) {
      console.error("Error In withdrawMultiple:", err);
      toastError(err?.reason || err?.message || "Transaction Failed");
      setBlockerStatus("error");
    } finally {
      settrdone(true);
    }
  };

  //  for offlinr check for transactio

  // const withdrawMultiple = async () => {
  //     settrdone(false);

  //     try {
  //         console.log("Processing withdrawal...");

  //         // Generate a random transaction hash
  //         const randomHash = utils.id(Math.random().toString());

  //         // Call backend API to register the withdrawal
  //         await axios.post(process.env.REACT_APP_BACKEND_LINK, {
  //             method: "withdrawal",
  //             submethod: "masswithdrw",
  //             key: process.env.REACT_APP_KEY,
  //             address: selected_address,
  //             username: selected_username,
  //             hash: randomHash, // Attach the generated hash
  //             amount: selected_address_amt_as,
  //             total: value, // Total withdrawal amount
  //         });

  //         // Uncheck checkboxes after processing withdrawal
  //         selected_address.forEach((_, i) => {
  //             const checkbox = document.getElementById(`chkbox${i}`);
  //             if (checkbox) checkbox.checked = false;
  //         });

  //         getData();
  //         setselected_address([]);
  //         setselected_username([]);
  //         setselected_address_amt([]);
  //         setValue(0);

  //         toastSuccess("Withdrawal Processed");

  //     } catch (err) {
  //         console.error("Error in withdrawMultiple:", err);
  //     }

  //     settrdone(true);
  // };

  const handleChange = (
    event,
    address,
    amount,
    username,
    fromname,
    totalrcv,
  ) => {
    // console.log('Event Triggered With Values:', address, amount, username, fromname, totalrcv);

    if (event?.target?.checked) {
      setselected_address((prevState) => {
        const updatedAddress = [...prevState, address];
        // console.log("Updated selected_address", updatedAddress);
        return updatedAddress;
      });

      setselected_username((prevState) => {
        const updatedUsername = [...prevState, username];
        // console.log("Updated selected_username", updatedUsername);
        return updatedUsername;
      });
      const amt = ethers.utils.parseEther(
        parseFloat(totalrcv || 0).toFixed(18),
      );
      // console.log("Amount In Wei:", amt.toString());

      setselected_address_amt((prevState) => {
        const updatedAmt = [...prevState, amt];
        // console.log("Updated selected_address_amt", updatedAmt);
        return updatedAmt;
      });

      setselected_address_amt_as((prevState) => {
        const updatedAmtAs = [...prevState, amount];
        // console.log("Updated selected_address_amt_as", updatedAmtAs);
        return updatedAmtAs;
      });

      setValue((prevValue) => {
        const updatedValue = prevValue + parseFloat(totalrcv);
        // console.log("Updated value", updatedValue);
        return parseFloat(updatedValue.toFixed(10));
      });
    } else {
      // When the checkbox is unchecked, remove the address, username, and amount from the selected lists
      const index = selected_address.findIndex((item) => item === address);

      if (index !== -1) {
        setselected_address((prevState) =>
          prevState.filter((_, ind) => ind !== index),
        );
        setselected_username((prevState) =>
          prevState.filter((_, ind) => ind !== index),
        );
        setselected_address_amt((prevState) =>
          prevState.filter((_, ind) => ind !== index),
        );
        setselected_address_amt_as((prevState) =>
          prevState.filter((_, ind) => ind !== index),
        );

        setValue((prevValue) => {
          const updatedValue = prevValue - parseFloat(totalrcv);
          return parseFloat(updatedValue.toFixed(10));
        });
      }
    }
  };

  // Now, useEffect can track state changes if you want to log after state has updated
  useEffect(() => {
    // console.log('selected_address', selected_address);
    // console.log('selected_username', selected_username);
    // console.log('selected_address_amt', selected_address_amt);
    // console.log('selected_address_amt_as', selected_address_amt_as);
  }, [
    selected_address,
    selected_username,
    selected_address_amt,
    selected_address_amt_as,
  ]); // This will log whenever these states change

  useEffect(() => {
    getData();
  }, [pageSize, currentPage, search, fromdate, todate, refreshKey]);

  useEffect(() => { }, [selected_address, selected_address_amt]);

  const onCheckboxChange = (
    e,
    address,
    amount,
    username,
    fromname,
    totalrcv,
  ) => {
    // console.log('onbox');

    e.preventDefault(); // prevent auto toggle

    Swal.fire({
      title: "Confirm Withdrawal",
      html: `Are you sure you want to process a withdrawal for <strong>${address}</strong>?`,
      icon: "warning",
      input: "text",
      inputPlaceholder: "Enter hash",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, proceed!",
      cancelButtonText: "Cancel",
      preConfirm: (inputValue) => {
        if (!inputValue) {
          Swal.showValidationMessage("You must enter a hash");
        }
        return inputValue; // Returns the input value to `.then(result => { ... })`
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const enteredHash = result.value;
        // console.log('Entered hash:', enteredHash);
        handleChangedirect(
          result.isConfirmed,
          e,
          address,
          amount,
          username,
          fromname,
          totalrcv,
          enteredHash,
        );
        // Proceed with withdrawal logic using enteredHash
      }
    });
  };
  const handleChangedirect = async (
    checked,
    event,
    address,
    amount,
    username,
    fromname,
    totalrcv,
    enteredHash,
  ) => {
    // console.log('Event Triggered With Values:', address, amount, username, fromname, totalrcv);
    // console.log('event?.target?.checked', checked);

    if (checked) {
      const updatedAddress = [address];
      const updatedUsername = [username];
      const updatedAmt = [totalrcv];
      const updatedAmtAs = [amount];
      const updateHashs = enteredHash;
      const updatedValue = value + parseFloat(totalrcv);

      // Set the updated state
      setselected_address(updatedAddress);
      setselected_username(updatedUsername);
      setselected_address_amt(updatedAmt);
      setselected_address_amt_as(updatedAmtAs);
      setValue(updatedValue);

      try {
        await axios.post(process.env.REACT_APP_BACKEND_LINK, {
          method: "withdrawal",
          submethod: "masswithdrw",
          key: process.env.REACT_APP_KEY,
          hash: enteredHash,
          address: updatedAddress,
          username: updatedUsername,
          amount: updatedAmtAs,
          total: updatedValue,
          enterhash: enteredHash,
        });

        // console.log("POST request successful");

        getData(); // Refresh data
        setselected_address([]);
        setselected_username([]);
        setselected_address_amt([]);
        setselected_address_amt_as([]);
        setValue(0); // Reset value
      } catch (err) {
        console.error("Error Sending Withdrawal Data:", err);
      }
    } else {
      // Handle unchecking
      const index = selected_address.findIndex((item) => item === address);

      if (index !== -1) {
        const updatedAddress = selected_address.filter(
          (_, ind) => ind !== index,
        );
        const updatedUsername = selected_username.filter(
          (_, ind) => ind !== index,
        );
        const updatedAmt = selected_address_amt.filter(
          (_, ind) => ind !== index,
        );
        const updatedAmtAs = selected_address_amt_as.filter(
          (_, ind) => ind !== index,
        );
        const updatedValue = value - parseFloat(totalrcv);

        setselected_address(updatedAddress);
        setselected_username(updatedUsername);
        setselected_address_amt(updatedAmt);
        setselected_address_amt_as(updatedAmtAs);
        setValue(updatedValue);
      }
    }
  };

  const handleReject = (username) => {
    Swal.fire({
      title: "Are you sure?",
      html: `
      <p style="margin-bottom:8px;">
        <strong>This withdrawal request will be rejected!</strong>
      </p>
      <p><b>Username:</b> ${username}</p>
   
    `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085D6",
      confirmButtonText: "Yes, Reject",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
            method: "withdrawal",
            submethod: "reject",
            username: username,

            key: process.env.REACT_APP_KEY,
          });
          // console.log('res.data?.error', res.data?.error);
          if (res.data?.resCode === 200) {
            Swal.fire("Rejected!", res.data.msg, "success");
            // :point_right: refresh list here if needed
            getData();
          } else {
            Swal.fire("Error", res.data?.error || "Failed", "error");
          }
        } catch (err) {
          Swal.fire("Error", "Server error", "error");
        }
      }
    });
  };
  const handleManualWithdrawal = async (username, amount) => {
    const hash = Date.now();
    const { value: msgManual, isConfirmed } = await Swal.fire({
      title: "Confirm Manual Withdrawal",
      html: `
      <p><b>Username:</b> ${username}</p>
      <p><b>Amount:</b> $${Number(amount).toFixed(2)}</p>
      <p style="color:red;">This withdrawal will be processed manually!</p>
    `,
      icon: "warning",
      input: "textarea",
      inputPlaceholder: "Type your message or reason here...",
      inputAttributes: {
        "aria-label": "Type your message or reason here",
      },
      showCancelButton: true,
      confirmButtonText: "Yes, Proceed",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#0D6EFD",
      cancelButtonColor: "#6C757D",
    });

    if (!isConfirmed) return;
    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "withdrawal",
        submethod: "manual",
        username,
        amount,
        hash,
        msg: msgManual,
        key: process.env.REACT_APP_KEY,
      });
      if (res.data?.resCode === 200) {
        Swal.fire("Success", res.data.msg, "success");
        getData();
      } else {
        Swal.fire("Error", res.data?.error || "Failed", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Server Error", "error");
    }
  };
  const generate3LetterHash = () => {
    const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 3; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  useEffect(() => {
    socket.on("withdraw-progress", (data) => {
      // console.log("SOCKET RECV:", data.status, data.completed, "/", data.total);

      // ✅ Case-insensitive matching to avoid mismatch (0xABC vs 0xabc)
      const match =
        jobId && data.jobId && data.jobId.toLowerCase() === jobId.toLowerCase();

      if (!jobId || match) {
        setProgress((prev) => ({
          ...prev,
          ...data,
        }));

        if (data.status === "processing") {
          setShowBlocker(true);
        }

        if (data.status === "done") {
          setBlockerStatus("success");
          settrdone(true);
        }

        if (data.status === "error") {
          setBlockerStatus("error");
          settrdone(true);
        }
      }
    });

    return () => socket.off("withdraw-progress");
  }, [jobId]);

  return (
    <>
      {showBlocker && (
        <div className="global-operation-blocker">
          <div className="blocker-content">
            {blockerStatus === "loading" ? (
              <>
                <div className="spinning-ring"></div>
                <i className="ri-error-warning-line forbidden-icon"></i>
                <p className="fw-bold">
                  {progress.status === "processing"
                    ? `Processing ${progress.completed} / ${progress.total}`
                    : txHash
                      ? "Confirming Transaction..."
                      : "Starting Withdrawal..."}
                </p>
                {progress.status === "processing" && (
                  <div className="w-100 mt-3">
                    <div className="d-flex justify-content-between mb-1">
                      <small>Progress</small>
                      <small>
                        {progress.completed} / {progress.total}
                      </small>
                    </div>

                    <div className="progress" style={{ height: "10px" }}>
                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        style={{
                          width: `${progress.total ? (progress.completed / progress.total) * 100 : 0}%`,
                        }}
                      />
                    </div>
                  </div>
                )}
              </>
            ) : blockerStatus === "success" ? (
              <>
                <div className="success-icon-wrapper">
                  <i className="ri-checkbox-circle-fill text-success fs-40"></i>
                </div>
                <p className="text-success">Withdrawal Completed!</p>
              </>
            ) : (
              <>
                <div className="error-icon-wrapper">
                  <i className="ri-close-circle-fill text-danger fs-40"></i>
                </div>
                <p className="text-danger">Transaction Failed</p>
              </>
            )}

            {txHash && (
              <div className="mt-2 text-center" style={{ minWidth: "280px" }}>
                <p className="mb-1 text-primary fs-14 fw-bold">TX HASH:</p>
                <a
                  href={`${process.env.REACT_APP_EXPLORER}/tx/${txHash}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-break text-muted fs-12 px-3 d-block"
                  style={{ textDecoration: "underline" }}
                >
                  {txHash}
                </a>
              </div>
            )}

            {blockerStatus !== "loading" ? (
              <button
                className={`btn ${blockerStatus === "success" ? "btn-success" : "btn-danger"} mt-3 px-5 fw-bold`}
                onClick={() => {
                  setShowBlocker(false);
                  setTxHash("");
                  setBlockerStatus("loading");
                  setProgress({
                    total: 0,
                    completed: 0,
                    status: "idle",
                  });
                  setJobId(null);
                }}
              >
                OK
              </button>
            ) : (
              <small className="mt-1">
                Page and Sidebar interaction is restricted during processing
              </small>
            )}
          </div>
        </div>
      )}
      <div
        id="layout-wrapper"
        style={{
          opacity: showBlocker && blockerStatus === "loading" ? 0.5 : 1,
          pointerEvents:
            showBlocker && blockerStatus === "loading" ? "none" : "all",
          transition: "all 0.3s ease",
        }}
      >
        <Header />
        <Sidebar />
        <div
          className="vertical-overlay"
          onClick={() => setIsSidebarEnabled((prev) => !prev)}
        ></div>
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* Page Title Section */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="javascript: void(0);">Tables</a>
                      </li>
                      <li className="breadcrumb-item active">
                        Pending Withdrwal
                      </li>
                    </ol>
                  </div>
                </div>
              </div>

              {/* Member Report Table Section */}
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-2">
                      <h4 className="card-title mb-0">Pending Withdrwal</h4>
                      {!loading && !isWithdrawalProcessing && (
                        <button
                          type="button"
                          className="btn btn-soft-primary btn-sm btn-icon rounded-circle material-shadow-none"
                          title="Refresh"
                          aria-label="Refresh pending withdrawals"
                          onClick={handleRefresh}
                        >
                          <i className="ri-refresh-line fs-16" />
                        </button>
                      )}
                    </div>
                    <div className="card-body">
                      <div className="listjs-table" id="customerList">
                        {/* Table Action Buttons */}
                        <div className="row g-4 mb-3">
                          <div className="col-sm-auto"></div>
                          <div className="col-sm">
                            <div className="d-flex justify-content-sm-end">
                              <div className="search-box ms-2">
                                <input
                                  type="text"
                                  className="form-control search"
                                  placeholder="Search..."
                                  value={search}
                                  disabled={loading || isWithdrawalProcessing}
                                  onChange={(e) => {
                                    setSearch(e.target.value);
                                    setCurrentPage(1);
                                  }}
                                />
                                <i className="ri-search-line search-icon" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex pe-5">
                          <div>
                            {account ? (
                              <>
                                <div className="mb-3">
                                  <h5 className="mb-1 text-break">
                                    🟢 {formatAddress(account)}
                                  </h5>
                                  <div className="d-flex align-items-center">
                                    <span className="text-muted fs-14">
                                      Total Selected:{" "}
                                    </span>
                                    <span className="text-primary fw-bold fs-15 ms-2">
                                      ${" "}
                                      {parseFloat(value || 0).toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 6,
                                        },
                                      )}
                                    </span>
                                  </div>
                                </div>

                                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                                  {/* Left Side */}
                                  <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      name="chkboxall"
                                      id="chkbox"
                                      onChange={(ed) => selectAll(ed)}
                                    />
                                    <label
                                      className="form-check-label fw-medium mb-0"
                                      htmlFor="chkbox"
                                    >
                                      Select All
                                    </label>
                                  </div>

                                  {/* Right Side Buttons */}
                                  <div className="d-flex gap-2">
                                    <button
                                      className="btn btn-success px-3"
                                      onClick={() => withdrawMultiple()}
                                      disabled={
                                        progress.status === "processing" ||
                                        selected_address.length === 0
                                      }
                                    >
                                      Give Withdrawal
                                    </button>

                                    <button
                                      className="btn btn-outline-danger px-3"
                                      onClick={() => disconnectNow()}
                                    >
                                      Disconnect
                                    </button>
                                  </div>
                                </div>

                                {trdone ? (
                                  ""
                                ) : (
                                  <img
                                    src="/assets/images/loader.gif"
                                    style={{ height: "80px" }}
                                    alt="Loading"
                                  />
                                )}
                              </>
                            ) : (
                              <>
                                <button
                                  className="btn btn-primary"
                                  onClick={() => connectMetamask()}
                                >
                                  Connect Wallet
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                        {/* Table */}
                        <div className="table-responsive table-card mt-3 mb-1">
                          <table
                            className="table align-middle table-nowrap"
                            id="customerTable"
                          >
                            <thead className="table-light">
                              <tr>
                                <th scope="col" style={{ width: "50px" }}></th>
                                <th className="gridjs-th text-center">#</th>
                                <th className="gridjs-th text-center">
                                  Address
                                </th>
                                {/* <th className="gridjs-th text-center"></th> */}
                                <th className="gridjs-th text-center">
                                  Amount
                                </th>
                                {/* <th className="gridjs-th text-center">Token</th> */}
                                <th className="gridjs-th text-center">Fee</th>
                                <th className="gridjs-th text-center">
                                  Total Receive
                                </th>
                                <th className="gridjs-th text-center">Date</th>
                                <th className="gridjs-th text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={TABLE_COL_SPAN} className="text-center py-5">
                                    <div
                                      className="spinner-border text-primary"
                                      role="status"
                                    >
                                      <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="text-muted mt-2 mb-0">
                                      Loading pending withdrawals...
                                    </p>
                                  </td>
                                </tr>
                              ) : data.length > 0 ? (
                                data.map((ele, i) => {
                                  const index =
                                    currentPage * pageSize - pageSize + (i + 1);
                                  return (
                                    <tr key={i}>
                                      <td className="gridjs-td">
                                        <div className="form-check">
                                          <input
                                            className="form-check-input row-check"
                                            type="checkbox"
                                            name={`chkbox${i}`}
                                            id={`chkbox${i}`}
                                            onChange={(ed) =>
                                              handleChange(
                                                ed,
                                                ele.sAddress,
                                                ele.amount,
                                                ele.username,
                                                ele.fromname,
                                                ele.totalrcv,
                                              )
                                            }
                                          />
                                          <label className="form-check-label"></label>
                                        </div>
                                      </td>
                                      <td className="gridjs-td text-center">
                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                          {/* STATUS CIRCLE */}
                                          <div
                                            title={ele.address === ele.sAddress ? "Address Match" : "Address Mismatch"}
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "50%",
                                              backgroundColor:
                                                ele.decryptedData?.address === ele.sAddress
                                                  ? "#28a745"
                                                  : "#dc3545",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              color: "#fff",
                                              fontSize: "11px",
                                              fontWeight: "bold"
                                            }}
                                          >
                                            {ele.sAddress === ele.decryptedData?.address ? "✓" : "✕"}
                                          </div>

                                          {/* INDEX */}
                                          <span>{index}</span>
                                        </div>
                                      </td>
                                      <td className="gridjs-td text-center">
                                        <div>
                                          <a
                                            target="_blank"
                                            className="text-primary"
                                            href={`${process.env.REACT_APP_EXPLORER}/address/${ele.sAddress}`}
                                            rel="noreferrer"
                                          >
                                            <span className="name-title">
                                              Address:
                                            </span>{" "}
                                            {ele.sAddress}
                                          </a>
                                          <Copy data={ele.sAddress} />{" "}
                                          {/* Use the Copy component */}
                                        </div>
                                        <div className="username-name">
                                          <span className="name-title">
                                            ID:
                                          </span>{" "}
                                          {ele.username || "-"}
                                          <Copy data={ele.username} />
                                        </div>
                                        <div className="username-name">
                                          <span className="name-title">
                                            Name:
                                          </span>{" "}
                                          {ele.fromname || "-"}
                                          <br />
                                          <span className="name-title">
                                            Email:
                                          </span>{" "}
                                          {ele.email || "-"}
                                          <Copy data={ele.fromname} />
                                        </div>
                                      </td>
                                      {/* <td className="gridjs-td text-center">Total Deposit: {ele.depositData[0]?.totalDeposit || 0} <br />
                                                                            Total Staking: {ele.stakingData[0]?.totalStaking || 0}
                                                                            </td> */}
                                      <td className="gridjs-td text-center">
                                        $ {ele.amount || "0"}
                                      </td>
                                      {/* <td className="gridjs-td text-center">
                                        {ele.token || "0"}
                                      </td> */}
                                      <td className="gridjs-td text-center">
                                        {parseFloat(ele.fee).toFixed(2)} (
                                        {ele.fee_per || "0"}%)
                                      </td>
                                      <td className="gridjs-td text-center">
                                        $ {ele.totalrcv || "0"}
                                      </td>
                                      <td className="gridjs-td text-center">
                                        {formatDateTime(ele.createdAt)}
                                      </td>
                                      <td className="gridjs-td text-center">
                                        <button
                                          className="btn btn-success m-1"
                                          onClick={(ed) =>
                                            onCheckboxChange(
                                              ed,
                                              ele.sAddress,
                                              ele.amount,
                                              ele.username,
                                              ele.fromname,
                                              ele.totalrcv,
                                            )
                                          }
                                        >
                                          Give
                                        </button>
                                        <button
                                          className="btn btn-danger"
                                          title="Reject Withdrwal"
                                          onClick={() =>
                                            handleReject(
                                              ele.username,

                                            )
                                          }
                                        >
                                          <i className="bi bi-trash3"></i>
                                        </button>
                                        <br />
                                        <button
                                          className="btn btn-primary"
                                          title="Give Manual Withdrawal"
                                          onClick={() =>
                                            handleManualWithdrawal(
                                              ele.username,
                                              ele.amount,
                                            )
                                          }
                                        >
                                          Manual
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan={TABLE_COL_SPAN} className="text-center py-4">
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination */}
                        <Pagination
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                          pageSize={pageSize}
                          setPageSize={setPageSize}
                          pages={pages}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />

      <style>
        {`
                .global-operation-blocker {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    background: rgba(255, 255, 255, 0.4);
                    backdrop-filter: blur(4px);
                    z-index: 99999;
                    cursor: not-allowed;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    pointer-events: all;
                }

                .blocker-content {
                    background: white;
                    padding: 40px;
                    border-radius: 30px;
                    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 15px;
                    border: 1px solid #f1f5f9;
                    max-width: 90%;
                    position: relative;
                }

                .forbidden-icon {
                    font-size: 32px;
                    color: #ef4444;
                    position: absolute;
                    top: 55px;
                }

                .spinning-ring {
                    width: 80px;
                    height: 80px;
                    border: 4px solid #f1f5f9;
                    border-top: 4px solid #405189;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                .blocker-content p {
                    font-weight: 800;
                    color: #1e293b;
                    margin: 0;
                    font-size: 18px;
                }

                .blocker-content small {
                    color: #64748b;
                    font-weight: 500;
                }
                `}
      </style>
    </>
  );
}
